export const REM_HEIGHT: number = 16;
export const CH_WIDTH: number = 8;

export const SIZES = {
  REM_HEIGHT,
  CH_WIDTH,

  characterWidth: (chars: number) => chars * CH_WIDTH,
  characterHeight: (chars: number) => chars * REM_HEIGHT
};



// WEBPACK FOOTER //
// ./src/app/shared/configs/sizes.ts